import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Button,
  message,
  Spin,
  Input,
  Select,
  Tag,
  Typography,
} from "antd";
import { useState, useCallback, useMemo, useEffect } from "react";
import {
  ReloadOutlined,
  FilterOutlined,
  FileSearchOutlined,
  SendOutlined,
  CalculatorOutlined,
} from "@ant-design/icons";
import { GET_GEO_ALL, HEADERS_EXPORT_BEN } from "../../API/apiUrls";
import axios from "axios";
import MotionHoc from "../../../utils/MotionHoc";
import RecordAverageModal from "./modal/RecordAverageModal";
import SendToLawyers from "../ceoManageContract/modal/SendToLawyers";

const { Option } = Select;
const { Text } = Typography;

/* ------------------------------------------------------------------ */
/* MOCK DATA — โครงสร้าง flat (1 record = 1 land)                       */
/* investigation: 1 = ทรัพย์ติดอายัด, 2 = ทรัพย์เฉลี่ยได้, 3 = เฉลี่ยไม่ได้ */
/* ------------------------------------------------------------------ */
const MOCK_ASSETS = [
  /* ===== สัญญา 2-0012446 : หจก. ทีเอ ทรานสปอร์ต ===== */
  {
    landId: 1334,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1845,
    invId: 577,
    customerId: 2031,
    investigation: 1,
    CUSCOD: "0653560003053",
    SNAM: "หจก.",
    NAME1: "ทีเอ ทรานสปอร์ต (2017)",
    NAME2: "",
    garno: 0,
    LOCAT: "LEX",
    numberLand: "84644",
    typeLand: 1,
    province: "43",
    district: "01",
    subdistrict: "07",
    provDesc: "หนองคาย",
    distDesc: "อ.เมืองหนองคาย",
    subDistDesc: "หาดคำ",
  },
  {
    landId: 1335,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1845,
    invId: 577,
    customerId: 2031,
    investigation: 2,
    CUSCOD: "0653560003053",
    SNAM: "หจก.",
    NAME1: "ทีเอ ทรานสปอร์ต (2017)",
    NAME2: "",
    garno: 0,
    LOCAT: "LEX",
    numberLand: "84927",
    typeLand: 1,
    province: "43",
    district: "01",
    subdistrict: "07",
    provDesc: "หนองคาย",
    distDesc: "อ.เมืองหนองคาย",
    subDistDesc: "หาดคำ",
    redCaseNo: "พ.123/2567",
    averageData: null,
  },
  {
    landId: 1336,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1846,
    invId: 577,
    customerId: 2031,
    investigation: 2,
    CUSCOD: "0653560003053",
    SNAM: "หจก.",
    NAME1: "ทีเอ ทรานสปอร์ต (2017)",
    NAME2: "",
    garno: 0,
    LOCAT: "LEX",
    numberLand: "11023",
    typeLand: 1,
    province: "41",
    district: "01",
    subdistrict: "01",
    provDesc: "อุดรธานี",
    distDesc: "อ.เมืองอุดรธานี",
    subDistDesc: "หมากแข้ง",
    redCaseNo: "พ.124/2567",
    averageData: null,
  },
  // กรุงเทพ (คนละโซน) -> แยกกลุ่ม
  {
    landId: 1337,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1847,
    invId: 577,
    customerId: 2031,
    investigation: 3,
    CUSCOD: "0653560003053",
    SNAM: "หจก.",
    NAME1: "ทีเอ ทรานสปอร์ต (2017)",
    NAME2: "",
    garno: 0,
    LOCAT: "LEX",
    numberLand: "55012",
    typeLand: 2,
    province: "10",
    district: "01",
    subdistrict: "01",
    provDesc: "กรุงเทพมหานคร",
    distDesc: "เขตพระนคร",
    subDistDesc: "พระบรมมหาราชวัง",
    redCaseNo: "พ.125/2567",
  },
  // คนค้ำในสัญญาเดียวกัน จังหวัดเดียวกับผู้เช่าซื้อ -> แยกกลุ่มเพราะคนละ customer
  {
    landId: 1338,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1848,
    invId: 577,
    customerId: 2032,
    investigation: 1,
    CUSCOD: "1451400111735",
    SNAM: "นาง",
    NAME1: "อุบลวัลย์",
    NAME2: "ธีระกูล",
    garno: 1,
    LOCAT: "LEX",
    numberLand: "84700",
    typeLand: 1,
    province: "43",
    district: "01",
    subdistrict: "07",
    provDesc: "หนองคาย",
    distDesc: "อ.เมืองหนองคาย",
    subDistDesc: "หาดคำ",
  },

  /* ===== สัญญา 2-0011000 : นาย สมชาย รุ่งเรือง ===== */
  {
    landId: 2001,
    invRoundId: 90,
    loanId: 901,
    contno: "2-0011000",
    assetOnlineId: 1990,
    invId: 601,
    customerId: 2105,
    investigation: 2,
    CUSCOD: "1100700123456",
    SNAM: "นาย",
    NAME1: "สมชาย",
    NAME2: "รุ่งเรือง",
    garno: 0,
    LOCAT: "LEX",
    numberLand: "20455",
    typeLand: 1,
    province: "50",
    district: "01",
    subdistrict: "01",
    provDesc: "เชียงใหม่",
    distDesc: "อ.เมืองเชียงใหม่",
    subDistDesc: "ศรีภูมิ",
    redCaseNo: "พ.501/2567",
    // ✅ mock: บันทึกข้อมูลเฉลี่ยไปแล้ว เพื่อโชว์การแสดงผลในคอลัมน์ "เฉลี่ยได้"
    averageData: {
      redCaseNo: "พ.501/2567",
      amount: 350000,
      averageDate: "2026-05-10",
      note: "เฉลี่ยจากการขายทอดตลาดนัดที่ 2",
    },
  },
  {
    landId: 2002,
    invRoundId: 90,
    loanId: 901,
    contno: "2-0011000",
    assetOnlineId: 1991,
    invId: 601,
    customerId: 2105,
    investigation: 3,
    CUSCOD: "1100700123456",
    SNAM: "นาย",
    NAME1: "สมชาย",
    NAME2: "รุ่งเรือง",
    garno: 0,
    LOCAT: "LEX",
    numberLand: "30781",
    typeLand: 1,
    province: "90",
    district: "01",
    subdistrict: "01",
    provDesc: "สงขลา",
    distDesc: "อ.เมืองสงขลา",
    subDistDesc: "บ่อยาง",
  },

  /* ===== สัญญา 1-0009999 : นาง วิภา ทองคำ ===== */
  {
    landId: 3001,
    invRoundId: 75,
    loanId: 770,
    contno: "1-0009999",
    assetOnlineId: 1500,
    invId: 540,
    customerId: 1899,
    investigation: 1,
    CUSCOD: "3650400999888",
    SNAM: "นาง",
    NAME1: "วิภา",
    NAME2: "ทองคำ",
    garno: 1,
    LOCAT: "LEX",
    numberLand: "78900",
    typeLand: 1,
    province: "12",
    district: "01",
    subdistrict: "01",
    provDesc: "นนทบุรี",
    distDesc: "อ.เมืองนนทบุรี",
    subDistDesc: "สวนใหญ่",
  },
];

/* ------------------------------------------------------------------ */
/* สถานะทรัพย์ — single source of truth                                 */
/* ------------------------------------------------------------------ */
const STATUS_META = {
  1: { label: "ทรัพย์ติดอายัด", color: "orange", icon: "📤" },
  2: { label: "ทรัพย์เฉลี่ยได้", color: "green", icon: "✅" },
  3: { label: "ทรัพย์เฉลี่ยไม่ได้", color: "red", icon: "❌" },
};
const STATUS_KEYS = Object.keys(STATUS_META).map(Number);

const statusOptions = STATUS_KEYS.map((value) => ({
  value,
  ...STATUS_META[value],
}));

const StatusTag = ({ status }) => {
  const m = STATUS_META[status];
  if (!m) return <Tag>ไม่ระบุ</Tag>;
  return <Tag color={m.color}>{m.label}</Tag>;
};

const norm = (v) =>
  String(v ?? "")
    .trim()
    .toLowerCase();

const fullName = (r) =>
  `${r.SNAM || ""}${r.NAME1 || ""} ${r.NAME2 || ""}`.trim();

const customerType = (garno) =>
  garno === 0 ? "ผู้เช่าซื้อ" : garno ? `คนค้ำที่ ${garno}` : "-";

const Main = () => {
  /* ----------------------------- States ---------------------------- */
  const [dataArr, setDataArr] = useState(MOCK_ASSETS);
  const [loading, setLoading] = useState(false);
  const [searchInputTable, setSearchInputTable] = useState("");
  const [processStatus, setProcessStatus] = useState(1); // null = ทั้งหมด

  // ✅ modal บันทึกข้อมูลเฉลี่ย
  const [isAverageOpen, setIsAverageOpen] = useState(false);
  const [averageGroup, setAverageGroup] = useState(null);

  // ✅ modal ส่งฟ้อง
  const [isSendLawsuitOpen, setIsSendLawsuitOpen] = useState(false);
  const [sendLawsuitData, setSendLawsuitData] = useState(null);

  // geo raw
  const [geo, setGeo] = useState({ province: [] });

  /* --------------------------- Load GEO ---------------------------- */
  useEffect(() => {
    let isMounted = true;
    const loadGeoData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(GET_GEO_ALL, {
          headers: HEADERS_EXPORT_BEN,
        });
        const d = res.data || {};
        if (isMounted) setGeo({ province: d.province || [] });
      } catch (error) {
        if (error.name !== "CanceledError" && isMounted) {
          message.error("ไม่สามารถโหลดข้อมูลพื้นที่ได้");
          console.error("❌ Error loading geo data:", error);
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    loadGeoData();
    return () => {
      isMounted = false;
    };
  }, []);

  /* ----------------------- helper: prov -> zone -------------------- */
  const provToZoneDesc = useCallback(
    (provCode) => {
      const p = geo.province.find(
        (x) => String(x.provCode) === String(provCode),
      );
      return p ? p.groupDesc : null;
    },
    [geo.province],
  );

  /* ----------------------- area source pool ------------------------ */
  const filteredLands = useMemo(() => {
    const q = norm(searchInputTable);
    return dataArr.filter((item) => {
      if (processStatus != null && item.investigation !== processStatus)
        return false;
      if (q) {
        const hay = [item.contno, item.CUSCOD, fullName(item)]
          .map(norm)
          .some((v) => v.includes(q));
        if (!hay) return false;
      }
      return true;
    });
  }, [dataArr, processStatus, searchInputTable]);

  // group ตาม เลขสัญญา + customer + จังหวัด
  const groupedTable = useMemo(() => {
    const groups = new Map();
    for (const rec of filteredLands) {
      const key = `${rec.contno}|${rec.customerId}|${rec.province}`;
      if (!groups.has(key)) {
        groups.set(key, {
          groupKey: key,
          contno: rec.contno,
          customerId: rec.customerId,
          CUSCOD: rec.CUSCOD,
          SNAM: rec.SNAM,
          NAME1: rec.NAME1,
          NAME2: rec.NAME2,
          garno: rec.garno,
          province: rec.province,
          provDesc: rec.provDesc,
          zoneDesc: provToZoneDesc(rec.province),
          // ✅ ข้อมูลเฉลี่ยทรัพย์ (ตัวแทนจาก rec แรกของกลุ่ม)
          redCaseNo: rec.redCaseNo,
          averageData: rec.averageData || null,
          lands: [],
        });
      }
      groups.get(key).lands.push(rec);
    }

    const arr = [...groups.values()].map((g) => {
      const statusCounts = STATUS_KEYS.reduce((acc, k) => {
        acc[k] = 0;
        return acc;
      }, {});
      g.lands.forEach((l) => {
        if (statusCounts[l.investigation] != null)
          statusCounts[l.investigation] += 1;
      });
      return { ...g, count: g.lands.length, statusCounts };
    });

    arr.sort((a, b) => {
      const c = String(a.contno).localeCompare(String(b.contno), "th");
      if (c !== 0) return c;
      if ((a.garno ?? 0) !== (b.garno ?? 0))
        return (a.garno ?? 0) - (b.garno ?? 0);
      return String(a.provDesc || "").localeCompare(
        String(b.provDesc || ""),
        "th",
      );
    });
    return arr;
  }, [filteredLands, provToZoneDesc]);

  const totalLands = useMemo(
    () => groupedTable.reduce((s, g) => s + g.count, 0),
    [groupedTable],
  );

  // ✅ สถานะของกลุ่ม (ถ้ามีสถานะเดียวให้คืนค่านั้น, ถ้าปนกันคืน null)
  const groupStatus = useCallback((g) => {
    const present = STATUS_KEYS.filter((k) => g.statusCounts[k] > 0);
    return present.length === 1 ? present[0] : null;
  }, []);

  const handleResetFilter = useCallback(() => {
    setSearchInputTable("");
    setProcessStatus(null);
    message.info("ล้างตัวกรองสำเร็จ");
  }, []);

  /* ------------------ Action: ส่งฟ้อง (สถานะติดอายัด) -------------- */
  const handleSendLawsuit = useCallback((group) => {
    setSendLawsuitData({
      CONTNO: group.contno,
      loanId: group.lands?.[0]?.loanId,
      lawsuitId: group.lawsuitId || 0,
      DATA_TYPE: group.DATA_TYPE || "lsfhp",
    });
    setIsSendLawsuitOpen(true);
  }, []);

  /* ------------ Action: บันทึกข้อมูลเฉลี่ย (สถานะเฉลี่ยได้) -------- */
  const handleOpenAverage = useCallback((group) => {
    setAverageGroup(group);
    setIsAverageOpen(true);
  }, []);

  const handleAverageSuccess = useCallback(({ group, data }) => {
    const ids = new Set((group.lands || []).map((l) => l.landId));
    setDataArr((prev) =>
      prev.map((land) =>
        ids.has(land.landId)
          ? { ...land, redCaseNo: data.redCaseNo, averageData: data }
          : land,
      ),
    );
    // TODO: reload จาก API จริงหลังบันทึก
  }, []);

  /* ------------------ สถานะรวมของกลุ่ม (parent) -------------------- */
  const renderGroupStatus = (g) => {
    const present = STATUS_KEYS.filter((k) => g.statusCounts[k] > 0);
    if (present.length === 0) return <span style={{ color: "#bbb" }}>-</span>;
    return (
      <Space size={4} wrap>
        {present.map((k) => (
          <Tag key={k} color={STATUS_META[k].color}>
            {STATUS_META[k].label} ({g.statusCounts[k]})
          </Tag>
        ))}
      </Space>
    );
  };

  /* --------------- ตารางย่อย: รายละเอียดแต่ละแปลง ----------------- */
  const expandedRowRender = (group) => {
    const detailColumns = [
      {
        title: "ลำดับ",
        key: "i",
        align: "center",
        width: 70,
        render: (_, __, i) => i + 1,
      },
      {
        title: "เลขที่ดิน",
        dataIndex: "numberLand",
        key: "numberLand",
        align: "center",
      },
      {
        title: "ประเภท",
        dataIndex: "typeLand",
        key: "typeLand",
        align: "center",
        render: (v) => (v === 1 ? "โฉนด" : v === 2 ? "นส.3" : (v ?? "-")),
      },
      {
        title: "อำเภอ",
        dataIndex: "distDesc",
        key: "distDesc",
        align: "center",
      },
      {
        title: "ตำบล",
        dataIndex: "subDistDesc",
        key: "subDistDesc",
        align: "center",
      },
      {
        title: "สถานะทรัพย์",
        key: "inv",
        align: "center",
        render: (_, r) => <StatusTag status={r.investigation} />,
      },
      {
        title: "จัดการ",
        key: "action",
        align: "center",
        width: 130,
        render: (_, r) => (
          <Button
            size="small"
            icon={<FileSearchOutlined />}
            onClick={() => {
              console.log("ดูข้อมูลแปลง:", r);
              message.info(`ดูข้อมูลที่ดินเลขที่ ${r.numberLand}`);
            }}
          >
            ดูข้อมูล
          </Button>
        ),
      },
    ];

    return (
      <Table
        size="small"
        columns={detailColumns}
        dataSource={group.lands}
        rowKey={(r) => r.landId}
        pagination={false}
        style={{ background: "#fafafa", borderRadius: 8 }}
      />
    );
  };

  /* --------------------- คอลัมน์หลัก (parent) --------------------- */
  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      width: 70,
      render: (_, __, index) => index + 1,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "contno",
      key: "contno",
      align: "center",
      width: 140,
      sorter: (a, b) => String(a.contno).localeCompare(String(b.contno), "th"),
      defaultSortOrder: "ascend",
      render: (v) => <Text strong>{v}</Text>,
    },
    {
      title: "ชื่อ-นามสกุลเจ้าของทรัพย์",
      key: "fullName",
      align: "left",
      render: (_, g) => fullName(g),
    },
    {
      title: "ประเภทลูกค้า",
      key: "garno",
      align: "left",
      render: (_, g) => customerType(g.garno),
    },
    {
      title: "เลขคดีแดง",
      key: "redCaseNo",
      align: "center",
      render: (_, g) =>
        g.redCaseNo || g.averageData?.redCaseNo ? (
          <Tag color="geekblue">{g.redCaseNo || g.averageData?.redCaseNo}</Tag>
        ) : (
          <span style={{ color: "#bbb" }}>-</span>
        ),
    },
    {
      title: "เฉลี่ยได้ (บาท)",
      key: "averageAmount",
      align: "right",
      width: 150,
      render: (_, g) =>
        g.averageData?.amount != null ? (
          <Text strong style={{ color: "#389e0d" }}>
            {Number(g.averageData.amount).toLocaleString("th-TH")}
          </Text>
        ) : (
          <span style={{ color: "#bbb" }}>-</span>
        ),
    },
    {
      title: "สถานะทรัพย์",
      key: "investigation",
      align: "center",
      width: 180,
      render: (_, g) => renderGroupStatus(g),
    },
    {
      title: "การจัดการ",
      key: "manage",
      align: "center",
      width: 180,
      render: (_, g) => {
        const st = groupStatus(g);
        if (st === 1) {
          return (
            <Button
              type="primary"
              size="small"
              icon={<SendOutlined />}
              onClick={() => handleSendLawsuit(g)}
            >
              ส่งฟ้อง
            </Button>
          );
        }
        if (st === 2) {
          return (
            <Button
              type="primary"
              ghost
              size="small"
              icon={<CalculatorOutlined />}
              onClick={() => handleOpenAverage(g)}
            >
              บันทึกข้อมูลเฉลี่ย
            </Button>
          );
        }
        return <span style={{ color: "#bbb" }}>-</span>;
      },
    },
  ];

  const stepBadge = (n, color) => (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 22,
        height: 22,
        borderRadius: "50%",
        background: color,
        color: "#fff",
        fontSize: 12,
        fontWeight: 700,
      }}
    >
      {n}
    </span>
  );

  /* ----------------------------- Render ---------------------------- */
  return (
    <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
      {/* ========== สถานะ + ค้นหา ========== */}
      <Card
        style={{
          marginBottom: 8,
          borderRadius: 12,
          border: "1px solid #ffcb05",
          background: "#fffdf0",
        }}
      >
        <Row align="middle" gutter={[8, 8]}>
          <Col xs={24} md={12}>
            <Space size={8} align="center">
              {stepBadge("1", "#efa420")}
              <FilterOutlined style={{ color: "#efa420" }} />
              <Text strong style={{ color: "#efa420" }}>
                เลือกสถานะทรัพย์
              </Text>
              <Select
                size="large"
                style={{ minWidth: 220 }}
                placeholder="เลือกสถานะ"
                value={processStatus}
                allowClear
                onChange={(v) => setProcessStatus(v ?? null)}
                optionLabelProp="label"
              >
                {statusOptions.map(({ value, icon, label }) => (
                  <Option key={value} value={value} label={`${icon} ${label}`}>
                    <Space>
                      <span>{icon}</span>
                      <span>{label}</span>
                    </Space>
                  </Option>
                ))}
              </Select>
            </Space>
          </Col>

          <Col xs={24} md={12} style={{ textAlign: "end" }}>
            <Space size={10} wrap>
              <Input
                placeholder="ค้นหาเลขสัญญา, ชื่อ"
                value={searchInputTable}
                onChange={(e) => setSearchInputTable(e.target.value)}
                style={{ width: 240, borderRadius: 8 }}
                size="small"
                allowClear
                suffix={<span>🔍</span>}
              />
              <Button
                icon={<ReloadOutlined />}
                onClick={handleResetFilter}
                size="large"
                style={{
                  borderRadius: 8,
                  backgroundColor: "#fff1f0",
                  borderColor: "#ffa39e",
                  color: "#cf1322",
                }}
              >
                ล้างตัวกรอง
              </Button>
            </Space>
          </Col>
        </Row>
      </Card>

      {/* ========== Table (group + expandable) ========== */}
      <Card>
        <Table
          size="small"
          columns={columns}
          dataSource={groupedTable}
          rowKey={(g) => g.groupKey}
          scroll={{ x: 1200 }}
          expandable={{
            expandedRowRender,
            rowExpandable: (g) => g.lands?.length > 0,
          }}
          pagination={{
            defaultPageSize: 10,
            showSizeChanger: true,
            showTotal: (total) => `ทั้งหมด ${total} กลุ่มทรัพย์`,
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          footer={() => (
            <p style={{ margin: 0 }}>
              จำนวนกลุ่มทรัพย์ {groupedTable.length} | จำนวนแปลงทั้งหมด{" "}
              {totalLands}
            </p>
          )}
        />
      </Card>

      {/* ========== Modal บันทึกข้อมูลเฉลี่ย ========== */}
      <RecordAverageModal
        open={isAverageOpen}
        onClose={setIsAverageOpen}
        group={averageGroup}
        onSuccess={handleAverageSuccess}
      />

      {/* ========== Modal ส่งฟ้อง ========== */}
      {isSendLawsuitOpen ? (
        <SendToLawyers
          open={isSendLawsuitOpen}
          close={setIsSendLawsuitOpen}
          dataDefault={sendLawsuitData}
          funcUpdateStatus={() => setDataArr((prev) => [...prev])}
        />
      ) : null}
    </Spin>
  );
};

const MainSelectAssetAverage = MotionHoc(Main);
export default MainSelectAssetAverage;
